/* unplugin-vue-components disabled */import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import Overlay from '@/components/Overlay.vue';
import CTypeTab from '@/components/CTypeTab.vue';
import { useEmptyStringFormat } from '@/hooks/fn';
// import useMortarSaleRank from './hooks/useMortarSaleRank';
import useMortarSaleTrend from './hooks/useMortarSaleTrend';
export default defineComponent({
  name: 'AggregateDailySalesCountReport',
  components: {
    Overlay: Overlay,
    CTypeTab: CTypeTab
  },
  // props: {
  //   type: {
  //     type: Number,
  //     required: true
  //   }
  // },
  setup: function setup() {
    var currentCustomerId = 0;
    var showOverlay = ref(false);
    var objectSpanMethod = function objectSpanMethod(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      console.log(column, rowIndex);
      // console.log(row, column, 'aaa');
      var res = {
        rowspan: 0,
        colspan: 0
      };
      if (columnIndex === 0) {
        if (currentCustomerId !== row.customer_id) {
          res = {
            rowspan: row.count,
            colspan: 1
          };
        }
        currentCustomerId = row.customer_id;
        console.log(res, 'aaa');
        return res;
      }
    };
    var tableRowClassName = function tableRowClassName(_ref2) {
      var row = _ref2.row;
      if (row.stone === '合计') {
        return 'success-row';
      }
      return '';
    };
    var params = ref({
      date: dayjs().format('YYYY/MM/DD'),
      type: 0 //时间类型 0日数据 1周数据 2月数据
    });
    var confrimDate = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params.value.date = val;
              // // getAggregateSaleRankAsync();
              // // getProdCmSaleVlBarAsync();
              // if (params.value.type === 3) {
              //   // getProdCmSaleVlBarYearAsync();
              // }
              loadGetAggregateSaleCountAsync();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function confrimDate(_x) {
        return _ref3.apply(this, arguments);
      };
    }();
    var dateRef = ref();
    var confirmType = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(val) {
        var _dateRef$value;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              params.value.type = val;
              //把所以日期控件的日期变为当前最新日期
              (_dateRef$value = dateRef.value) === null || _dateRef$value === void 0 || _dateRef$value.reset();
              if (val === 4) {
                params.value.date = dayjs().format('YYYY/MM/DD') + ',' + dayjs().format('YYYY/MM/DD');
              } else {
                params.value.date = dayjs().format('YYYY/MM/DD');
              }
              loadGetAggregateSaleCountAsync();
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function confirmType(_x2) {
        return _ref4.apply(this, arguments);
      };
    }();
    var switchClick = function switchClick() {
      // if (params.value.type === 0) {
      //   window.location.href = `/table/shajiangSellDay.html?factoryId=${localCache.getItem(
      //     'factoryId'
      //   )}`;
      // }
      // if (params.value.type === 1) {
      //   window.location.href = `/table/shajiangSellWeek.html?factoryId=${localCache.getItem(
      //     'factoryId'
      //   )}`;
      // }
      // if (params.value.type === 2) {
      //   window.location.href = `/table/shajiangSellMonth.html?factoryId=${localCache.getItem(
      //     'factoryId'
      //   )}`;
      // }
    };
    // const [aggregateSaleRankData, getAggregateSaleRankAsync] =
    //   useMortarSaleRank(params);
    // getAggregateSaleRankAsync();
    var emptyStringFormat = useEmptyStringFormat();
    var _useMortarSaleTrend = useMortarSaleTrend(params),
      _useMortarSaleTrend2 = _slicedToArray(_useMortarSaleTrend, 6),
      getAggregateSaleCountAsync = _useMortarSaleTrend2[4],
      aggregateSaleCountData = _useMortarSaleTrend2[5];
    var loadGetAggregateSaleCountAsync = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              showOverlay.value = true;
              _context3.next = 4;
              return getAggregateSaleCountAsync();
            case 4:
              _context3.prev = 4;
              showOverlay.value = false;
              return _context3.finish(4);
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0,, 4, 7]]);
      }));
      return function loadGetAggregateSaleCountAsync() {
        return _ref5.apply(this, arguments);
      };
    }();
    loadGetAggregateSaleCountAsync();
    var router = useRouter();
    var toReportDetail = function toReportDetail() {
      router.push({
        name: 'SaleReportDetail',
        params: {
          date: params.value.date,
          type: params.value.type,
          reportType: 'mortar' //砂浆商砼砂浆
        }
      });
    };
    return {
      params: params,
      showOverlay: showOverlay,
      confirmType: confirmType,
      confrimDate: confrimDate,
      switchClick: switchClick,
      emptyStringFormat: emptyStringFormat,
      toReportDetail: toReportDetail,
      dateRef: dateRef,
      aggregateSaleCountData: aggregateSaleCountData,
      objectSpanMethod: objectSpanMethod,
      tableRowClassName: tableRowClassName
    };
  }
});